// extracted by mini-css-extract-plugin
module.exports = {"container":"SourceSet_container__Ad9ec","square":"SourceSet_square__XQifR","portrait":"SourceSet_portrait__Y9Ql_","landscape":"SourceSet_landscape__vpgTE"};